import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-img-reference',
  templateUrl: './img-reference.component.html',
  styleUrls: ['./img-reference.component.css']
})
export class ImgReferenceComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
